import NewFacilityCommon, {
    OptionSettingForNewFacility,
    ReservationSettingsForNewFacility,
    ServerImageInformation,
} from './NewFacilityCommon'
import {Nullable} from '../../app/TypeHelpers'

export interface StaySettingsForNewFacility {
    stayPossibleDateCount: number
    stayContinueTimeRental: string
    checkinTime: string
    checkoutTime: string
    stayCharge: number
}

export default class NewFacilityForOvernightRental extends NewFacilityCommon {
    staySetting: StaySettingsForNewFacility

    constructor(
        sortOrder: number,
        categoryId: string | null,
        equipmentIds: number[],
        facilityName: string,
        accessControlManager: string | null,
        cardKeyFacilityNumber: string | null,
        gateNumbers: string[] | null,
        images: ServerImageInformation[],
        facilityIntroductory: string,
        optionSettings: OptionSettingForNewFacility[],
        reservationSetting: ReservationSettingsForNewFacility,
        releaseSetting: string,
        releaseStartDate: Nullable<string>,
        releaseStartTime: Nullable<string>,
        reserveBeforeCleaningTime: number,
        reserveAfterCleaningTime: number,
        staySetting: StaySettingsForNewFacility,
    ) {
        super(
            sortOrder,
            categoryId,
            equipmentIds,
            facilityName,
            accessControlManager,
            cardKeyFacilityNumber,
            gateNumbers,
            images,
            facilityIntroductory,
            optionSettings,
            reservationSetting,
            releaseSetting,
            releaseStartDate,
            releaseStartTime,
            reserveBeforeCleaningTime,
            reserveAfterCleaningTime,
        )

        this.staySetting = staySetting
    }
}
